<div class="metadata z-1"><div class="t-sm dark-gray">Intros selected by manager</div><i class="mi onboarding-grid-event-footer-icon">person_pin</i></div>